<template>
  <div class="breadcrumb">
    <div class="breadcrumb__width" ref="breadcrumb">
      <a
        class="breadcrumb__all"
        @click="toSelectCoursePage($event)"
        >选课中心</a
      >
      <i class="before before-margin" v-if="siftGrades"></i>
      <div
        class="breadcrumb__dropdown breadcrumb__all breadcrumb__text-color"
        @mouseenter="showDropdownGD()"
        @mouseleave="hiddenDropdownGD()"
        v-if="siftGrades"
      >
        <div class="dropdown-link">
          <span>{{ siftGrade.name }}</span>
          <span
            class="iconfont2 icon-angledown icon dropdown__icon"
            :class="{ 'img--rotate': isShowDropdownGD }"
          ></span>
        </div>
        <div
          class="dropdown-select-list"
          v-if="isShowDropdownGD"
          :class="{ 'dropdown--show': isShowDropdownGD }"
        >
          <ul class="select-list-container">
            <li
              class="select-list-item"
              @click="handleGrade(item)"
              v-for="(item, index) in siftGrades"
              :key="index"
            >
              <span class="item-name">{{ item.name }}</span>
            </li>
            <div class="popper__arrow" style="left: 67px;"></div>
          </ul>
        </div>
      </div>
      <i class="before before-margin" v-if="siftCourseType"></i>
      <div
        class="breadcrumb__dropdown breadcrumb__all breadcrumb__text-color"
        @mouseenter="showDropdownCT()"
        @mouseleave="hiddenDropdownCT()"
        v-if="siftCourseType"
      >
        <div class="dropdown-link">
          <span>{{ siftCourseType.name }}</span>
          <span
            class="iconfont2 icon-angledown icon dropdown__icon"
            :class="{ 'img--rotate': isShowDropdownCT }"
          ></span>
        </div>
        <div
          class="dropdown-select-list"
          v-if="isShowDropdownCT"
          :class="{ 'dropdown--show': isShowDropdownCT }"
        >
          <ul class="select-list-container">
            <li
              class="select-list-item"
              @click="handleCourseType(item)"
              v-for="(item, index) in siftCourseTypes"
              :key="index"
            >
              <span class="item-name">{{ item.name }}</span>
            </li>
            <div class="popper__arrow" style="left: 67px;"></div>
          </ul>
        </div>
      </div>
      <i class="before before-margin" v-if="siftSubjects"></i>
      <div
        class="breadcrumb__dropdown breadcrumb__all breadcrumb__text-color"
        @mouseenter="showDropdownSJ()"
        @mouseleave="hiddenDropdownSJ()"
        v-if="siftSubject"
      >
        <div class="dropdown-link">
          <span>{{ siftSubject.name }}</span>
          <span
            class="iconfont2 icon-angledown icon dropdown__icon"
            :class="{ 'img--rotate': isShowDropdownSJ }"
          ></span>
        </div>
        <div
          class="dropdown-select-list"
          v-if="isShowDropdownSJ"
          :class="{ 'dropdown--show': isShowDropdownSJ }"
        >
          <ul class="select-list-container">
            <li
              class="select-list-item"
              @click="handleSubject(item)"
              v-for="(item, index) in siftSubjects"
              :key="index"
            >
              <span class="item-name">{{ item && item.name }}</span>
            </li>
            <div class="popper__arrow" style="left: 67px;"></div>
          </ul>
        </div>
      </div>
      <template v-if="siftBread && Object.keys(siftBread).length > 0">
        <div
          class="breadcrumb__alreayFilter"
          v-for="(value, key, index) of siftBread"
          :key="index"
        >
          <span class="before"></span>
          <p class="breadcrumb__breadcrumbItem">
            <span class="color-r middle">{{ siftNames[key] }}：</span>
            <span class="color-r middle">{{ value.name }}</span>
            <span
              class="middle hover-img close-img"
              :style="{
                backgroundImage:
                  index === Object.keys(siftBread).length - 1
                    ? 'url(' + require('../img/bread_close_black.png') + ')'
                    : 'url(' + require('../img/bread_close_gray.png') + ')'
              }"
              :class="{ isLastImg: index === Object.keys(siftBread).length - 1 }"
              @click.prevent="closeItem(key, $event)"
            >
            </span>
          </p>
        </div>
      </template>
    </div>
    <div class="absolute-item">
      <div
        class="breadcrumb__clean"
        @click="closeAll($event)"
        v-if="siftBread && Object.keys(siftBread).length > 0"
      >
        清除筛选条件
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import filterSubject from '@/util/filterSubject'
export default {
  data() {
    return {
      isShowMore: false,
      // subjects: chooseSift.subjects,
      // teacherMtypes: chooseSift.teacherMtypes,
      subject: '',
      isShowDropdownCT: false,
      isShowDropdownSJ: false,
      isShowDropdownGD: false
    }
  },
  computed: {
    ...mapState({
      siftGrades: state => state.CourseCenter.siftGrades,
      siftGrade: state => state.CourseCenter.siftGrade,
      siftCourseTypes: state => state.CourseCenter.siftCourseTypes,
      siftCourseType: state => state.CourseCenter.siftCourseType,
      siftBread: state => state.CourseCenter.siftBread,
      siftNames: state => state.CourseCenter.siftNames,
      siftSubjects: state => state.CourseCenter.siftSubjects,
      siftSubject: state => state.CourseCenter.siftSubject,
      subjectEnum: state => state.subjectEnum
    }),
    // siftCourseType () {
    //   const { courseType } = this.$route.params
    //   const courseTypeItem = this.siftCourseTypes && this.siftCourseTypes.filter(item => {
    //     return Number(item.id) === Number(courseType)
    //   })
    //   return courseTypeItem && courseTypeItem.length > 0 ? courseTypeItem[0] : null
    // },
    searchSiftLog() {
      let obj = Object.create(null)
      if (
        this.searchSift &&
        this.searchSift.constructor === Object &&
        Object.keys(this.searchSift).length > 0
      ) {
        let keysArr = Object.keys(this.searchSift)
        for (let item of keysArr) {
          let arr = this.searchSift[item].map(_item => {
            return _item.id
          })
          obj[item] = arr
        }
      }
      return obj
    },
    siftBreadLog() {
      let obj = Object.create(null)
      for (let item in this.siftBread) {
        obj[item] = this.siftBread[item].id
      }
      return obj
    }
  },
  methods: {
    toSelectCoursePage(e) {
      const gradeId = this.$route.params.grade
      const subjectId = this.$route.params.subject
      const url = `https://online.xueersi.com/select-course?gradeId=${gradeId}&subjectId=${subjectId}`
      window.location.href = url

      this.xesLog(
        'click',
        { clickid: '1.3.55', key: 'xeslog-click-breadcrumb-coursecenter' },
        e
      )
    },
    showDropdownGD() {
      this.isShowDropdownGD = true
    },
    hiddenDropdownGD() {
      this.isShowDropdownGD = false
    },
    showDropdownCT() {
      this.isShowDropdownCT = true
    },
    hiddenDropdownCT() {
      this.isShowDropdownCT = false
    },
    showDropdownSJ() {
      this.isShowDropdownSJ = true
    },
    hiddenDropdownSJ() {
      this.isShowDropdownSJ = false
    },
    handleGrade(item) {
      const grade = item.id
      const courseType = 0
      const subject = 0
      this.$router.push({
        name: this.$route.name,
        params: { courseType, grade, subject },
        query: {
          switch_grade: grade,
          switch_subject: -1
        }
      })
      this.isShowDropdownGD = false
    },
    handleCourseType(item) {
      const newQuery = {
        switch_subject: '-1',
        switch_grade: this.$route.query.switch_grade
      }
      const { grade } = this.$route.params
      const courseType = item.id
      let subject = 0
      if (Number(courseType) === -25) {
        subject = -925
      }
      this.$router.push({
        name: this.$route.name,
        params: { courseType, grade, subject },
        query: newQuery
      })
      this.isShowDropdownCT = false
    },
    handleSubject(item) {
      const { params } = this.$route
      const subject = item.id
      const newQuery = {
        switch_grade: this.$route.query.switch_grade,
        switch_subject: filterSubject(subject, this.subjectEnum)
      }
      this.$router.push({
        name: this.$route.name,
        params: { ...params, subject },
        query: newQuery
      })
      this.isShowDropdownSJ = false
    },
    // 清除所有筛选条件
    async closeAll(event) {
      const newQuery = Object.create(null)
      this.$router.push({
        name: this.$route.name,
        query: newQuery
      })
      this.xesLog(
        'click',
        {
          clickid: '1.4.31',
          key: `xeslog-search-closeAllSift`,
          choose_option: this.searchSift && this.searchSiftLog,
          choosed_option: this.chooseSiftLog
        },
        event
      )
    },
    deleteQuery(oldQuery, keyName) {
      const newObj = {}
      for (let key in oldQuery) {
        if (key !== keyName) {
          newObj[key] = oldQuery[key]
        }
      }
      return newObj
    },
    closeItem(item, event) {
      // 关闭面包屑某一项
      const { query } = this.$route
      const newQuery = this.deleteQuery(query, item) // 将关闭的项从链接中删除
      this.$router.push({
        name: this.$route.name,
        params: this.$route.params,
        query: { ...newQuery }
      })
      const clickIdTypes = {
        grades: '1.4.11',
        subjects: '1.4.12',
        difficulties: ' 1.4.13',
        terms: '1.4.14',
        timeTypes: '1.4.15',
        timeSlots: '1.4.16',
        liveTypeIds: '1.4.17',
        versions: '1.4.18',
        type: '1.4.9'
      }
      const itemClickId = clickIdTypes[item]
      this.xesLog(
        'click',
        {
          clickid: itemClickId,
          navlocation: item,
          attribute: query[item],
          key: `xeslog-courseCenter-closeSift-${item}`
        },
        event
      )
    },
    xesLog(eventName, params, event) {
      const XESLog = new this.$XESLog({
        ...params,
        setgradeid: this.$store.state.cookies.userGrade,
        curgradeid: this.$store.state.cookies.currentGrade
      })
      XESLog.push({ eventname: eventName, target: event.target }, this.$route)
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/entry';
@include b(breadcrumb) {
  max-width: 100%;
  padding-bottom: 20px;
  position: relative;
  @include e(all) {
    flex-shrink: 0;
    color: #999999;
    display: inline-block;
    font-size: 12px;
    line-height: 22px;
    margin-top: 18px;
  }
  @include e(text-color) {
    color: #333;
  }
  @include e(alreayFilter) {
    display: inline-block;
    margin-top: 18px;
    flex-shrink: 0;
  }
  .before {
    display: inline-block;
    height: 12px;
    width: 12px;
    background: url('../img/jiantou.png');
    background-size: 12px 12px;
    background-repeat: no-repeat;
    background-position: center;
    padding: 0 4px;
    vertical-align: middle;
  }
  @include e(breadcrumbItem) {
    font-size: 12px;
    display: inline-block;
    margin: 0;
    border: 1px solid rgba(153, 153, 153, 1);
    color: #333333;
    padding-left: 4px;
    border-radius: 2px;
    .middle {
      display: inline-block;
      height: 20px;
      line-height: 20px;
      vertical-align: middle;
    }
    .close-img {
      background-size: 12px 12px;
      background-repeat: no-repeat;
      background-position: center;
      padding: 0 10px;
      vertical-align: middle;
    }
    &:hover {
      cursor: pointer;
      border: solid 1px #f13232;
      color: #f13232;
      .hover-img {
        background-image: url('../img/bread_close.png') !important;
      }
    }
  }
  @include e(clean) {
    box-sizing: border-box;
    display: inline-block;
    font-size: 12px;
    border: solid 1px #cccccc;
    line-height: 20px;
    padding: 0 8px;
    cursor: pointer;
    vertical-align: middle;
    &:hover {
      color: #f13232;
    }
  }
}
.breadcrumb__width {
  max-width: 1000px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}
.siftMore {
  display: inline-block;
  margin-left: 16px;
  width: 77px;
  height: 22px;
  font-size: 12px;
  border: solid 1px #cccccc;
  cursor: pointer;
  padding: 0 8px;
  box-sizing: border-box;
  &:hover {
    color: #f13232;
  }
  span {
    display: inline-block;
    vertical-align: middle;
    line-height: 20px;
  }
  img {
    display: inline-block;
    margin-left: 3px;
    vertical-align: middle;
    width: 8px;
    height: 5px;
    transition: all 0.2s;
  }
  .rotate {
    transform: rotate(180deg);
  }
}
.absolute-item {
  position: absolute;
  right: 0;
  top: 16px;
  color: #666666;
}
.el-dropdown-menu__item {
  font-size: 12px;
}
.dropdown-link {
  // box-sizing: border-box;
  border: 1px solid rgba(153, 153, 153, 1);
  color: #333333;
  border-radius: 2px;
  padding-left: 4px;
  height: 20px;
  display: flex;
  justify-items: center;
  &:hover {
    color: #f13232;
    border: 1px solid rgba(241, 50, 50, 1);
    .icon {
      color: #f13232;
      transform: rotate(180deg);
    }
  }
  span {
    line-height: 20px;
  }
  .dropdown__icon {
    display: inline-block;
    font-size: 13px;
    // width: 20px;
    // height: 20px;
    // color: #999999;
    cursor: pointer;
    transition: transform 0.3s;
    margin-right: 4px;
  }
}
.dropdown-select-list {
  position: absolute;
  left: 0;
  z-index: 2008;
  // max-height: 230px;
  transform-origin: center top;
  .dropdown--show {
    opacity: 1;
    transition: height 1s;
  }
}
.select-list-container {
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
  border-radius: 2px;
  border: 1px solid rgba(245, 245, 245, 1);
  text-align: center;
  padding: 8px 0;
  margin: 5px 0;
  background-color: #fff;
  // max-height: 200px;
  // overflow-y: auto;
  outline: 0;
  min-width: 100px;
  .select-list-item {
    color: #afafaf;
    list-style: none;
    line-height: 36px;
    padding: 0 14px;
    margin: 0;
    font-size: 12px;
    outline: 0;
    white-space: nowrap;
    &:hover {
      background: #f5f5f5;
    }
    & > span {
      color: #212831;
      font-size: 12px;
    }
  }
}
.breadcrumb__dropdown {
  position: relative;
}
.before-margin {
  margin-top: 18px;
}
</style>



// WEBPACK FOOTER //
// ./src/views/CourseCenter/components/SiftBreadcrumb.vue